import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=b45b15c0&scoped=true"
import script from "./jobList.vue?vue&type=script&lang=js"
export * from "./jobList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45b15c0",
  null
  
)

export default component.exports